import { KIND } from 'baseui/button'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import ActivatedPanel from '../ActivatedPanel/ActivatedPanel'
import AppConnection from '../AppConnection/AppConnection'
import ConnectionChoice from '../ConnectionChoice/ConnectionChoice'
import EmailConnection from '../EmailConnection/EmailConnection'
import OnboardingSteps from '../OnboardingSteps'
import SendPanel from '../SendPanel/SendPanel'
import SentBox from '../SentBox/SentBox'
import StatusPills from '../StatusPills/StatusPills'
import type { FidelityJourneyProps } from '../types'
import { StyledButtonBlock, StyledJourney } from '../styled-components'

const FidelityJourney = ({
  hidden,
  pills,
  stepsHidden,
  steps,
  pdlWarning,
  contactWarning,
  send,
  appLinks,
  sentBox,
  noCode,
  choice,
  codeOnlyNotice,
  app,
  email,
  activated,
  maximized,
  error,
  resend,
}: FidelityJourneyProps) => {
  if (hidden) {
    return null
  }

  return (
    <StyledJourney>
      <StatusPills items={pills} />
      <SDNotification hidden={pdlWarning.hidden} type='warning' primaryText={pdlWarning.text} />
      <OnboardingSteps hidden={stepsHidden} steps={steps} />
      <SDNotification hidden={contactWarning.hidden} type='warning' primaryText={contactWarning.text} />
      <SendPanel {...send} />
      <SendPanel {...appLinks} />
      <SentBox {...sentBox} />
      <SDNotification hidden={noCode.hidden} type='info' iconType='default' primaryText={noCode.text} />
      <ConnectionChoice {...choice} />
      <SDNotification hidden={codeOnlyNotice.hidden} type='info' iconType='default' primaryText={codeOnlyNotice.text} />
      <AppConnection {...app} />
      <EmailConnection {...email} />
      <ActivatedPanel {...activated} />
      <SDNotification hidden={maximized.hidden} type='positive' iconType='trophy' primaryText={maximized.text} />
      <SDNotification hidden={error.hidden} type='error' primaryText={error.text} />
      <StyledButtonBlock hidden={resend.hidden}>
        {/* @ts-ignore */}
        <SDButton
          block={true}
          kind={KIND.secondary}
          disabled={resend.disabled}
          isLoading={resend.loading}
          onClick={resend.onClick}
        >
          {resend.label}
        </SDButton>
      </StyledButtonBlock>
    </StyledJourney>
  )
}

export default FidelityJourney
